
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.5 17.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.4 7.7c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-3.7 3.7c-.3.3-.8.3-1.1 0L4 8.8c-.3-.3-.2-.8.1-1.1.3-.2.7-.2 1 0l2.5 2.5V.8c0-.4.3-.8.8-.8.4 0 .8.3.8.8v9.4l2.2-2.5zM.8 17.2c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h15c.4 0 .8.3.8.8s-.3.8-.8.8H.8z","fill":"#044370"}})])
          )
        }
      }
    